var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#FFFFFF"}},[_vm._m(0),_c('div',{staticStyle:{"margin-top":"50px"}},[_c('contentIndex',{attrs:{"initInfo":_vm.info}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"top_img1",attrs:{"src":require("../../assets/img/shujufenxi.jpeg")}})])
}]

export { render, staticRenderFns }